import { render, staticRenderFns } from "./departMentSelector.vue?vue&type=template&id=8dd894fc"
import script from "./departMentSelector.vue?vue&type=script&lang=js"
export * from "./departMentSelector.vue?vue&type=script&lang=js"
import style0 from "./departMentSelector.vue?vue&type=style&index=0&id=8dd894fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports